"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
const projects = [{
  title: "House of Contrast",
  location: "Tennessee, USA",
  imageSrc: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/8519e210-6768-45ab-bed8-8646a34ef2961.jpg?v=5sqksifj2u3",
  imageSrcset: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/8519e210-6768-45ab-bed8-8646a34ef2961.jpg?v=qf03tf3bcsn-wvc-srcset",
  imageSizes: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/8519e210-6768-45ab-bed8-8646a34ef2961.jpg?v=x96u08chf8-wvc-sizes",
  alt: "House of Contrast luxury architecture and interior design in Tennessee",
  link: "#"
}, {
  title: "House 303",
  location: "Michigan, USA",
  imageSrc: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/90afa795-9cb7-4cfa-9353-6833354e4725.png?v=obnwksujsur",
  imageSrcset: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/90afa795-9cb7-4cfa-9353-6833354e4725.png?v=idag2m436re-wvc-srcset",
  imageSizes: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/90afa795-9cb7-4cfa-9353-6833354e4725.png?v=t3ygwlja1xh-wvc-sizes",
  alt: "House 303 evening exterior and reflection pool courtyard",
  link: "#"
}, {
  title: "The Bridge House",
  location: "Michigan, USA",
  imageSrc: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/89231070-f70b-44f1-8f1c-fd6c080dd978-1.png?v=n75wgy4w8kb",
  imageSrcset: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/89231070-f70b-44f1-8f1c-fd6c080dd978-1.png?v=2oe0no4piqm-wvc-srcset",
  imageSizes: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/89231070-f70b-44f1-8f1c-fd6c080dd978-1.png?v=qd7r88gmk5-wvc-sizes",
  alt: "The Bridge House panoramic residence overlooking mountain and city",
  link: "#"
}, {
  title: "The Play Loft",
  location: "Upper Peninsula, USA",
  imageSrc: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/7f9ccfc3-a6b8-48a8-aaf5-44e960c79938.png?v=2o5jbyp7hsu",
  imageSrcset: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/7f9ccfc3-a6b8-48a8-aaf5-44e960c79938.png?v=ka7xznlb3fe-wvc-srcset",
  imageSizes: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/7f9ccfc3-a6b8-48a8-aaf5-44e960c79938.png?v=gkgwyqxotet-wvc-sizes",
  alt: "The Play Loft bespoke sculptural wine cellar and travertine lounge",
  link: "#"
}, {
  title: "Curated Stays",
  location: "Short Term Rentals, USA",
  imageSrc: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/airbnb-1-1.png?v=4wospf0bofe",
  imageSrcset: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/glen_villa_living_room.webp?v=2ynpjolpdsa-wvc-srcset",
  imageSizes: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/glen_villa_living_room.webp?v=h2dcesz8j1s-wvc-sizes",
  alt: "The Curated Stay modern open-concept living area with full-height glazing",
  link: "#"
}, {
  title: "Forest Hill",
  location: "Coming Soon",
  imageSrc: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/High-resolution-renovation-rendering-noon-scaled.png?v=9cvy0z7eyfp",
  imageSrcset: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/High-resolution-renovation-rendering-noon-scaled.png?v=8yqluc0t3hv-wvc-srcset",
  imageSizes: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/High-resolution-renovation-rendering-noon-scaled.png?v=1j03ttrok1f-wvc-sizes",
  alt: "Forest Hill master suite with unobstructed ocean sunset views",
  link: "#"
}, {
  title: "Table Blanc",
  location: "Coming Soon",
  imageSrc: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/Table-Blanc-exterior.png?v=9pfimqtpfam",
  imageSrcset: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/Table-Blanc-exterior.png?v=flw6me0wso-wvc-srcset",
  imageSizes: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/Table-Blanc-exterior.png?v=0pk1aj7922h-wvc-sizes",
  alt: "Hatta desert retreat luxury pavilion bedroom and lounge",
  link: "#"
}, {
  title: "Derm Society",
  location: "Coming Soon",
  imageSrc: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/Derm-Society-interior.jpeg?v=lkc84b0ijd",
  imageSrcset: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/Derm-Society-interior.jpeg?v=fykadozm3x-wvc-srcset",
  imageSizes: "https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/Derm-Society-interior.jpeg?v=hkwze16wz5-wvc-sizes",
  alt: "Waterside bespoke custom furniture and warm timber panelling",
  link: "#"
}];
export default function PortfolioGrid() {
  const prefersReducedMotion = useReducedMotion();
  return <section id="portfoliogrid" data-nav="light" className="w-full bg-background text-foreground">
      <div className="w-full">
        <h2 className="sr-only">Selected Architecture & Interior Projects</h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-[2px] bg-border/40">
          {projects.map((project, index) => {
          return <motion.article key={project.title} data-index={index} initial={prefersReducedMotion ? {
            opacity: 1
          } : {
            opacity: 0,
            scale: 0.98
          }} whileInView={prefersReducedMotion ? {
            opacity: 1
          } : {
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true,
            amount: 0.15
          }} transition={{
            duration: 0.6,
            ease: "easeOut"
          }} className="group relative overflow-hidden bg-background aspect-[4/3] md:aspect-[16/11] w-full">
                <Link to={project.link} className="block h-full w-full relative outline-none focus-visible:ring-2 focus-visible:ring-foreground focus-visible:ring-offset-2" aria-label={`${project.title}, ${project.location}`}>
                  <div className="absolute inset-0 overflow-hidden bg-muted">
                    <img src={project.imageSrc} data-wvc-srcset={project.imageSrcset} data-wvc-sizes={project.imageSizes} alt={project.alt} loading="lazy" decoding="async" className={`h-full w-full ${index === 4 ? "object-contain bg-muted" : "object-cover"} object-center transition-[transform] duration-500 ease-out group-hover:scale-[1.03]`} />
                  </div>

                  <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/10 to-transparent pointer-events-none transition-[opacity] duration-300 group-hover:opacity-80" />

                  <div className="absolute top-6 left-6 md:top-8 md:left-8 z-10 pointer-events-none">
                    <h3 className="text-white text-xs md:text-sm font-sans tracking-[0.2em] uppercase font-medium leading-snug drop-shadow-xs">
                      {project.title}
                    </h3>
                    <p className="text-white/80 text-[10px] md:text-xs font-sans tracking-[0.18em] uppercase mt-0.5 leading-relaxed drop-shadow-xs">
                      {project.location}
                    </p>
                  </div>
                </Link>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}